var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slider" }, [
    _c(
      "div",
      { staticClass: "bar" },
      [
        _c("yxt-slider", {
          attrs: {
            "input-size": "mini",
            value: _vm.value,
            max: _vm.max,
            vertical: "",
            height: "97px",
          },
          on: { input: _vm.handleInput },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "text" }, [
      _vm._v("\n    " + _vm._s(_vm.value) + "%\n  "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }